var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions-options",
    transform: "translate(-1100.000000, -452.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-Options",
    transform: "translate(687.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(0.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9285714,18.2142857 L34.7857143,18.2142857 L34.7857143,16.0714286 C34.7850353,15.4799764 34.3057379,15.000679 33.7142857,15 L24.0714286,15 C23.4799764,15.000679 23.000679,15.4799764 23,16.0714286 L23,25.7142857 C23.000679,26.3057379 23.4799764,26.7850353 24.0714286,26.7857143 L26.2142857,26.7857143 L26.2142857,28.9285714 C26.2149647,29.5200236 26.6942621,29.999321 27.2857143,30 L36.9285714,30 C37.5200236,29.999321 37.999321,29.5200236 38,28.9285714 L38,19.2857143 C37.999321,18.6942621 37.5200236,18.2149647 36.9285714,18.2142857 Z M24.25,16.25 L33.6244792,16.25 L33.6244792,18.8534896 L33.6244792,18.8541667 L33.6244792,18.8548438 L33.625,25.625 L24.25,25.625 L24.25,16.25 Z M36.75,28.75 L27.375,28.75 L27.375,26.6666667 L33.625,26.6666667 C34.200023,26.6660065 34.6660065,26.200023 34.6666667,25.625 L34.6666667,19.375 L36.75,19.375 L36.75,28.75 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateNew);
export default __webpack_public_path__ + "static/media/duplicate-new.9e6d0bb60c85faea68419a2641fff8f4.svg";
export { ForwardRef as ReactComponent };